<div class="uk-container">
	<div class="CatalogItem" itemscope itemtype="http://schema.org/Product">
		<div class="uk-grid" uk-grid>
			<div class="CatalogItem_RightCol uk-width-1-2@l uk-flex-last@m">
				<h1 itemprop="name">{{ h1Text }}</h1>

				<!-- <div *ngIf="data.DETAIL_TEXT_TYPE === 'text'" class="CatalogItem_Description">{{data.DETAIL_TEXT}}</div> -->
				<div class="CatalogItem_Description" [innerHtml]="data.DETAIL_TEXT" itemprop="description"></div>

				<div *ngIf="data.OFFERS" class="uk-margin">
					<div class="uk-margin-small-bottom">{{ data.OFFERS[offerIndex].PROPS[0].NAME }}</div>
					<select class="uk-select" name="offers" [(ngModel)]="offerIndex">
						<option *ngFor="let offer of data.OFFERS; index as i" [value]="i">{{ offer.PROPS[0].VALUE_ENUM }}</option>
					</select>
				</div>

				<div class="uk-margin">
					<div class="uk-margin-small-bottom">Количество</div>
					<app-touchspin *ngIf="!data.OFFERS"
						[value]="quantity"
						[max]="data.BASE_PRICE.PRODUCT_CAN_BUY_ZERO === 'N' ? data.BASE_PRICE.PRODUCT_QUANTITY : 10"
						(change)="quantity = $event"
					></app-touchspin>

					<app-touchspin *ngIf="data.OFFERS"
						[value]="quantity"
						[max]="data.OFFERS[offerIndex].PRICE.PRICE.PRODUCT_QUANTITY"
						(change)="quantity = $event"
					></app-touchspin>
				</div>

				<div class="uk-flex uk-flex-middle uk-flex-between" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
					<div *ngIf="!data.OFFERS" class="CatalogItem_Price">
						<meta itemprop="price" content="{{data.BASE_PRICE.PRICE}}">
						<meta itemprop="priceCurrency" content="RUB">
						<strong><span *ngIf="data.BASE_PRICE.QUANTITY_FROM">от </span>{{data.BASE_PRICE.PRICE | currency:data.BASE_PRICE.CURRENCY : 'symbol' : '1.0-0'}}</strong>
					</div>

					<div *ngIf="data.OFFERS" class="CatalogItem_Price">
						<meta itemprop="price" content="{{data.OFFERS[offerIndex].PRICE.RESULT_PRICE.BASE_PRICE}}">
						<meta itemprop="priceCurrency" content="RUB">
						<strong><span *ngIf="data.OFFERS[offerIndex].PRICE.PRICE.QUANTITY_FROM">от </span
						><span *ngIf="data.OFFERS[offerIndex].PRICE.RESULT_PRICE.PERCENT" style="text-decoration: line-through">{{data.OFFERS[offerIndex].PRICE.RESULT_PRICE.BASE_PRICE | currency:data.OFFERS[offerIndex].PRICE.RESULT_PRICE.CURRENCY : 'symbol' : '1.0-0'}}</span>
						{{data.OFFERS[offerIndex].PRICE.RESULT_PRICE.DISCOUNT_PRICE | currency:data.OFFERS[offerIndex].PRICE.RESULT_PRICE.CURRENCY : 'symbol' : '1.0-0'}}
						<span *ngIf="data.OFFERS[offerIndex].PRICE.RESULT_PRICE.PERCENT"> скидка {{ data.OFFERS[offerIndex].PRICE.RESULT_PRICE.PERCENT }} %</span></strong>
					</div>

					<div class="uk-flex uk-flex-middle">
						<!-- <span *ngIf="!data.IS_IN_COMPARE" class="CatalogItem_Compare" (click)="addToCompare()">
							<span class="IconItem IconItem--compare"></span>
							<span>К сравнению</span>
						</span>

						<span *ngIf="data.IS_IN_COMPARE" class="CatalogItem_Compare uk-text-primary" (click)="removeFromCompare()">
							<span class="IconItem IconItem--compare"></span>
							<span>В сравнении</span>
						</span> -->

						<button *ngIf="!data.OFFERS" class="uk-button uk-button-primary"
							type="button"
							(click)="addToCart()"
							[disabled]='loadingState || !data.CAN_BUY'
							[ngClass]='loadingState ? "uk-button-loading" : ""'
						>Заказать</button>

						<button *ngIf="data.OFFERS" class="uk-button uk-button-primary"
							type="button"
							(click)="addToCart()"
							[disabled]='loadingState || !data.OFFERS[offerIndex].PRICE.PRICE.CAN_BUY'
							[ngClass]='loadingState ? "uk-button-loading" : ""'
						>Заказать</button>
					</div>
				</div>
			</div>

			<div class="CatalogItem_Slider uk-width-1-2@l">
				<div uk-slideshow="animation: scale; ratio: 1:1">
				    <ul *ngIf="data.PROPERTY_MORE_PHOTO_VALUE && data.PROPERTY_MORE_PHOTO_VALUE.VALUE.length > 0" class="uk-slideshow-items">
						<li *ngFor="let image of data.PROPERTY_MORE_PHOTO_VALUE.VALUE" class="CatalogItem_Slider_Item uk-flex uk-flex-middle uk-flex-center">
							<img [src]="image.SRC" [alt]="image.DESCRIPTION || data.NAME" itemprop="image">
							<div *ngIf="image.DESCRIPTION" class="uk-transition-slide-bottom uk-position-bottom uk-overlay">
								<p class="uk-margin-remove">{{image.DESCRIPTION}}</p>
							</div>
						</li>
				    </ul>

					<ul *ngIf="!data.PROPERTY_MORE_PHOTO_VALUE || data.PROPERTY_MORE_PHOTO_VALUE.VALUE.length === 0" class="uk-slideshow-items">
						<li class="CatalogItem_Slider_Item uk-flex uk-flex-middle uk-flex-center uk-transition-toggle">
							<img *ngIf="data.DETAIL_PICTURE" [src]="data.DETAIL_PICTURE.SRC" [alt]="data.DETAIL_PICTURE.DESCRIPTION || data.NAME" itemprop="image">
							<span *ngIf="!data.DETAIL_PICTURE" class="uk-h1 uk-margin-remove uk-position-center">Нет фото</span>
						</li>
					</ul>

				    <div *ngIf="data.PROPERTY_MORE_PHOTO_VALUE && data.PROPERTY_MORE_PHOTO_VALUE.VALUE.length > 0" class="uk-margin-medium-top">
				        <ul class="CatalogItem_Slider_Thumbs uk-thumbnav" uk-margin="margin: uk-margin-medium-top">
				            <li *ngFor="let image of data.PROPERTY_MORE_PHOTO_VALUE.VALUE; index as i" [attr.uk-slideshow-item]="i">
								<a class="CatalogItem_Slider_Thumbs_Item uk-background-cover" [style.background-image]="'url(' + image.SRC + ')'"></a>
							</li>
				        </ul>
				    </div>
				</div>
			</div>
		</div>

		<h2 class="characteristics">Характеристики</h2>
		<div class="CatalogItem_Params">
			<div *ngFor="let prop of data.PROPERTIES" class="CatalogItem_Param uk-flex">
				<div class="CatalogItem_Param_Name">{{prop.NAME}}</div>
				<div class="CatalogItem_Param_Description">{{prop.VALUE}}</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="otherProducts.length > 0" class="uk-background-muted">
	<div class="uk-container">
		<recommend-slider [items]="otherProducts"></recommend-slider>
	</div>
</div>
